var exports = {
  "az": "Box__o8ADE0",
  "wy": "Box_1__QzfrBc",
  "pv": "Box_2__dZ2Hqo",
  "Pb": "Breadcrumbs_Item__9uBrnx",
  "w9": "Box_3__gV2ay0",
  "vb": "VerifiedHTMLBox__JqnIhK",
  "pQ": "Box_4__siBMll",
  "ws": "Box_5__i1EwrX",
  "N_": "Link__ekZFFr",
  "EY": "Text__0dV0fq",
  "D6": "Box_6__GFtIVF",
  "UE": "Text_1__Azwgwl",
  "KI": "Box_7__D0Oy_a",
  "bx": "Link_1__coIFvu",
  "m4": "Octicon__urfetV",
};

module.exports = exports;
